export default [
  {
    name: '数字孪生',
    hash: 'metaverse',
  },
  {
    name: '未来工厂',
    hash: 'metaverse',
  },
  {
    name: '业务协同平台',
    hash: 'coop',
  },
  {
    name: '数字资产超市',
    hash: 'digitalTwin',
  },
]
